import React from 'react';
import ColorInput from '@uber/react-qna-lib/src/components/common/Input';
import { Accordion, Panel } from 'baseui/accordion';
import { Button, KIND, SHAPE } from 'baseui/button';
import { Card } from 'baseui/card';
import { Checkbox, LABEL_PLACEMENT } from 'baseui/checkbox';
import { FormControl } from 'baseui/form-control';
import { Plus, TrashCanFilled } from 'baseui/icon';
import { Input } from 'baseui/input';
import { Select } from 'baseui/select';
import { HeadingSmall, HeadingXSmall } from 'baseui/typography';
import { YOLO_LABELS } from '../../../consts/yoloLabels';
import type { AnnotationLabelWithMetadataT } from '../../../types/annotationLabelWithMetadata';
import type { QuestionnaireInputT } from '../../../types/questionnaireInput';
type ProjectAnnotationFormProps = {
  annotationLabels: AnnotationLabelWithMetadataT[];
  questionnaires: QuestionnaireInputT[];
  setAnnotationLabels: React.Dispatch<React.SetStateAction<AnnotationLabelWithMetadataT[]>>;
};
const hslToHex = (h: number, s: number, l: number) => {
  s /= 100;
  l /= 100;
  const a = s * Math.min(l, 1 - l);
  const f = n => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(color * 255).toString(16).padStart(2, '0');
  };
  return `#${f(0)}${f(8)}${f(4)}`;
};
const getRandomBrightHex = () => {
  const h = Math.random() * 360;
  const s = 80;
  const l = 80;
  return hslToHex(h, s, l);
};
const getLabelTitleError = (title: string, labels: AnnotationLabelWithMetadataT[], index: number) => {
  if (!title) {
    return 'Label is required';
  }
  const duplicate = labels.find((label, i) => label.title === title && i !== index);
  if (duplicate) {
    return 'Label must be unique';
  }
  return '';
};
const ProjectAnnotationForm = (props: ProjectAnnotationFormProps) => {
  const {
    annotationLabels,
    setAnnotationLabels
  } = props;
  return <Card>
      <HeadingXSmall style={{
      margin: '0'
    }}>
        Labels{' '}
        <Button shape={SHAPE.circle} kind={KIND.tertiary} onClick={() => {
        const randomColor = getRandomBrightHex();
        setAnnotationLabels([...annotationLabels, {
          title: '',
          description: '',
          style: {
            fillColor: randomColor,
            fillOpacity: 0.4,
            strokeColor: randomColor,
            strokeWidth: 0
          },
          metadata: {}
        }]);
      }}>
          <Plus />
        </Button>
      </HeadingXSmall>
      <Accordion>
        {annotationLabels.map((label, index) => {
        return <Panel title={<div>
                  <span>Label {label.title}</span>
                  <Button shape={SHAPE.circle} kind={KIND.tertiary} onClick={() => {
            const newLabels = [...annotationLabels];
            newLabels.splice(index, 1);
            setAnnotationLabels(newLabels);
          }}>
                    <TrashCanFilled />
                  </Button>
                </div>} key={index}>
              <FormControl label="Title" error={getLabelTitleError(label.title, annotationLabels, index)}>
                <Input value={label.title} onChange={e => {
              const newLabels = [...annotationLabels];
              // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
              newLabels[index].title = e.currentTarget.value;
              setAnnotationLabels(newLabels);
            }} placeholder="Enter title" />
              </FormControl>
              <FormControl label="Description">
                <Input value={label.description} onChange={e => {
              const newLabels = [...annotationLabels];
              // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
              newLabels[index].description = e.currentTarget.value;
              setAnnotationLabels(newLabels);
            }} placeholder="Enter Description" />
              </FormControl>

              <FormControl label="Max">
                <Input type="number" min={0} value={label.max} onChange={e => {
              const newLabels = [...annotationLabels];
              // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
              newLabels[index].max = +e.currentTarget.value;
              setAnnotationLabels(newLabels);
            }} placeholder="Enter max" />
              </FormControl>
              <Checkbox checked={label.isRequired} onChange={e => {
            const newLabels = [...annotationLabels];
            // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
            newLabels[index].isRequired = e.target.checked;
            setAnnotationLabels(newLabels);
          }} labelPlacement={LABEL_PLACEMENT.right}>
                Required?
              </Checkbox>
              <FormControl label="Yolo Mapping">
                <Select options={YOLO_LABELS.map(label => ({
              id: label
            }))} labelKey="id" valueKey="id" placeholder="Choose Yolo mapping" maxDropdownHeight="300px" onChange={({
              value
            }) => {
              const newLabels = [...annotationLabels];
              // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
              newLabels[index].metadata = {
                // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
                ...(newLabels[index].metadata || {}),
                yoloLabelName: value[0]?.id?.toString()
              };
              setAnnotationLabels(newLabels);
            }} value={label.metadata?.yoloLabelName ? [{
              id: label.metadata?.yoloLabelName
            }] : undefined} />
              </FormControl>
              <FormControl label="Label Questionnaire">
                <Select options={props.questionnaires} labelKey="name" valueKey="questionnaireId" placeholder="Choose questionnaire" maxDropdownHeight="300px" multi onChange={({
              value
            }) => {
              const newLabels = [...annotationLabels];
              // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
              newLabels[index].questionnaire = value.map(item => ({
                questionnaireId: item.questionnaireId,
                workspaceId: '',
                name: item.name
              }));
              setAnnotationLabels(newLabels);
            }} value={label.questionnaire} />
              </FormControl>
              <Card>
                <HeadingSmall>Style</HeadingSmall>
                <FormControl label="Stroke Color">
                  <ColorInput type="color" value={label.style.strokeColor} onChange={e => {
                const newLabels = [...annotationLabels];
                // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
                newLabels[index].style.strokeColor = e.currentTarget.value;
                setAnnotationLabels(newLabels);
              }} placeholder="Enter Stroke Color" />
                </FormControl>
                <FormControl label="Fill Color">
                  <ColorInput type="color" value={label.style.fillColor} onChange={e => {
                const newLabels = [...annotationLabels];
                // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
                newLabels[index].style.fillColor = e.currentTarget.value;
                setAnnotationLabels(newLabels);
              }} placeholder="Enter Fill Color" />
                </FormControl>
                <FormControl label="Fill Opacity">
                  <Input type="number" min={0} max={1} step={0.1} value={label.style.fillOpacity} onChange={e => {
                const newLabels = [...annotationLabels];
                // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
                newLabels[index].style.fillOpacity = +e.currentTarget.value;
                setAnnotationLabels(newLabels);
              }} placeholder="Enter Fill Opacity" />
                </FormControl>
                <FormControl label="Stroke Width">
                  <Input type="number" min={0} value={label.style.strokeWidth} onChange={e => {
                const newLabels = [...annotationLabels];
                // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
                newLabels[index].style.strokeWidth = +e.currentTarget.value;
                setAnnotationLabels(newLabels);
              }} placeholder="Enter Stroke Width" />
                </FormControl>
              </Card>
            </Panel>;
      })}
      </Accordion>
    </Card>;
};
export default ProjectAnnotationForm;